// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610231318/js/" + chunkId + "." + {"44":"d429e378","225":"9370e0ba","481":"a52c5721","486":"45948d3c","770":"ea4dc124"}[chunkId] + ".0.8941784031882597.chunk.js";
};